import type { ID, SellableType } from '@nutralab/api';

/** One cart line per product: ids are unique per type only, so bundle 1 and offer 1 are different keys. */
export function getCartKey({ type, id }: { type: SellableType; id: ID }): string {
    return `${type}:${id}`;
}
